import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';

export const organizationContactStore = {
  actions,
  asyncActions,
};

export default reducer;
